<button type="button" class="header" (click)="toggle()">
  <ng-content select="fb-expansion-panel-header" />
  <rx-icon name="icon-expand" class="header-icon" [size]="12" />
</button>
<div class="body">
  <ng-content select="fb-expansion-panel-content" />
</div>
